// Where an account created with a short bootstrap password is held (D48) until it chooses a new
// one: the sign-in frame, not the console, because nothing else answers until it has.
import { browser, signOutAndLeave } from "../auth/api";
import { PasswordForm } from "../auth/PasswordForm";
import { useT } from "../i18n";
import { LanguageMenu } from "../ui/LanguageMenu";
import { SignInLayout } from "./SignInLayout";

export default function ChoosePasswordPage({ email }: { email: string }) {
  const t = useT().auth.choose;
  return (
    <SignInLayout actions={<LanguageMenu />}>
      <h1 className="text-[28px] tracking-tight lg:text-[32px]">{t.title}</h1>
      <p className="mb-0 mt-2 text-[14px] leading-relaxed text-gray-500">{t.lead(<span className="font-medium text-gray-800">{email}</span>)}</p>
      <div className="mt-8">
        <PasswordForm
          submitLabel={t.submit}
          onChanged={() => browser.reloadTo("/")}
        />
      </div>
      <button type="button" className="mt-6 self-start text-[13px] font-medium text-gray-500 hover:text-primary" onClick={() => void signOutAndLeave()}>
        {t.signOutInstead}
      </button>
    </SignInLayout>
  );
}
